// Importa y exporta todos los archivos de idioma aquí
import { en } from "./en";
import { zh } from "./zh";

// Exporta un objeto con los idiomas disponibles, usando el código de idioma como clave
export default {
  en,
  zh,
};
